class MolodaBuyNow extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
    this._onVariantChange = this._onVariantChange.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === "true") return;

    this._form = document.forms[this.getAttribute("form")] || document.getElementById(this.getAttribute("form"));
    this._button = this.querySelector("button");

    if (!this._form || !this._button) return;

    this.dataset.initialized = "true";
    this._button.addEventListener("click", this._onClick);
    this._form.addEventListener("variant:change", this._onVariantChange);
  }

  disconnectedCallback() {
    this._button?.removeEventListener("click", this._onClick);
    this._form?.removeEventListener("variant:change", this._onVariantChange);
  }

  _onVariantChange(event) {
    this._button.disabled = !event.detail.variant || !event.detail.variant.available;
  }

  async _onClick() {
    if (!this._form.checkValidity()) {
      this._form.reportValidity();
      return;
    }

    const variantInput = this._form.querySelector('[name="id"]');

    if (!variantInput?.value) {
      this._showError(this.getAttribute("error-message"));
      return;
    }

    this._button.disabled = true;
    this._button.setAttribute("aria-busy", "true");

    try {
      const formData = new FormData(this._form);
      formData.set("id", variantInput.value);

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      });

      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || this.getAttribute("error-message"));
      }

      window.location.assign(`${window.Shopify.routes.root}checkout`);
    } catch (error) {
      this._button.removeAttribute("aria-busy");
      this._button.disabled = false;
      this._showError(error.message || this.getAttribute("error-message"));
    }
  }

  _showError(message) {
    this._form.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: { error: message }
    }));
  }
}

if (!window.customElements.get("moloda-buy-now")) {
  window.customElements.define("moloda-buy-now", MolodaBuyNow);
}
